
<ls-color-picker [id]="question.key"
                 [formControlName]="question.key">
</ls-color-picker>
